var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserLogout = function SvgUserLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.16 31.18 33.34 26H14v-4h19.34l-5.18-5.18L31 14l10 10-10 10zM38 6a4 4 0 0 1 4 4v9.34l-4-4V10H10v28h28v-5.34l4-4V38a4 4 0 0 1-4 4H10a4 4 0 0 1-4-4V10c0-2.22 1.78-4 4-4z"
  })));
};
export default SvgUserLogout;